module.exports = __webpack_public_path__ + "img/twism-light.f2b2039c.svg";